import { render, staticRenderFns } from "./BindWeChat.vue?vue&type=template&id=5c03d44c&scoped=true"
import script from "./BindWeChat.vue?vue&type=script&lang=js"
export * from "./BindWeChat.vue?vue&type=script&lang=js"
import style0 from "./BindWeChat.vue?vue&type=style&index=0&id=5c03d44c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c03d44c",
  null
  
)

export default component.exports